// extracted by mini-css-extract-plugin
export default {"inner":"styles_inner__GroIL","icon":"styles_icon__FKBZp","chooseFileBtn":"styles_chooseFileBtn__xpVkk","text":"styles_text__QFqdn","main":"styles_main__md0AH"};